export enum ScriptDocType {
    Light = 'SCRIPT_LIGHT',
    Full = 'SCRIPT_FULL',
    Domiciliazione = 'SCRIPT_DOMICILIAZIONE', 
    Preventivo = 'PREVENTIVO', 
    Cessazione = 'SCRIPT_CESSAZIONI', 
}
